import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { PaymentFormComponent } from "@app/views/regularisation-schedule/payment-form/payment-form.component";
import { PopupEventsPaymentComponent } from "@app/views/regularisation-schedule/popup-events-payment/popup-events-payment.component";
import { TranslateModule } from "@ngx-translate/core";
import { TOKEN } from "@shared/constants/localstorage.constants";
import { REGULARISATION_OFF } from "@shared/constants/route.constants";
import { ReceiptDetail } from "@shared/models/payment";
import { PaymentService } from "@shared/services/payment.service";
import { Guid } from "guid-typescript";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-payment-request",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CardModule,
    DividerModule,
    PaymentFormComponent,
    PopupEventsPaymentComponent,
    TranslateModule,
  ],
  templateUrl: "./payment-request.component.html",
  styleUrl: "./payment-request.component.scss",
})
export class PaymentRequestComponent implements OnInit {
  hasToken = false;
  paymentSuccess!: boolean;
  showPopupPayment!: boolean;

  name = "";
  productName = "";
  numeroContrat = "";
  amount = 0;
  receiptDetails: ReceiptDetail[] = [];
  formToken = "";
  hasUnpaidReceipts = false;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly paymentService: PaymentService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.hasToken = !!localStorage.getItem(TOKEN);
    this.route.queryParamMap.subscribe((params: ParamMap) =>
      this.paymentService.getSummaryPayment(Guid.parse(params.get("policy")!)).subscribe(data => {
        if (data.debtDetails.hasUnpaidReceipts) {
          this.router.navigate([REGULARISATION_OFF], {
            queryParams: { policy: params.get("policy") },
          });
        }
        this.hasUnpaidReceipts = data.debtDetails.hasUnpaidReceipts;
        this.name = data.debtDetails.memberFullName;
        this.productName = data.debtDetails.productName;
        this.numeroContrat = data.debtDetails.reference;
        this.amount = data.debtDetails.amount;
        this.receiptDetails = data.debtDetails.receiptDetails;
        this.formToken = data.formToken;
      })
    );
  }

  paymentEvent(event: boolean) {
    this.paymentSuccess = event;
  }

  showPopup(show: boolean) {
    this.showPopupPayment = show;
    this.cdr.detectChanges();
  }
}
